import { FieldValue } from '../../data-objects'
import { FieldType } from './field-type'

export abstract class FieldDefinition {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
  public name: string
  public idml: string
  public description: string
  public readClaim: string
  public writeClaim: string
  public fieldDefinitionType: FieldType
  public entityName: string
  public isSystem: boolean
  public code: string

  constructor(field?: FieldDefinition) {
    this.name = ''
    this.idml = ''
    this.description = ''
    this.readClaim = ''
    this.writeClaim = ''
    this.fieldDefinitionType = 'String'
    this.entityName = ''
    this.isSystem = false
    this.code = ''
    if (field) {
      const keys = Object.getOwnPropertyNames(field)
      keys.forEach((key) => {
        this[key] = field[key]
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public abstract getFieldValue(value?: FieldValue<any> | null): FieldValue<any>

  public static mapField<T extends FieldDefinition>(fieldObj: FieldDefinition): T {
    const keys = Object.getOwnPropertyNames(fieldObj)
    const toReturn = <FieldDefinition>{}
    keys.forEach((key) => {
      toReturn[key] = fieldObj[key]
    })

    return toReturn as T
  }
}
